import React, {useEffect, useState} from "react";
import "./CommonHomeworkEditorPage.sass"
import Window from "../../../_containers/window/Window";
import {useDispatch, useSelector} from "react-redux";
import "./CommonHomeworkEditorPage.sass";
import CircleButton from "../../../_components/common/buttons/CircleButton";
import CloseIcon from "@mui/icons-material/Close";
import {Navigate, useNavigate, useParams} from "react-router";
import ButtonComponent from "../../../_components/common/buttons/ButtonComponent";
import HomeworkSetting from "../../../_components/common/HomeworkSetting";
import {FAILED, IDLE, LOADING, SUCCESS} from "../../../common/statuses";
import {getSettingByHWId} from "../../../_actions/game/gameService";
import Spinner from "../anonymous/Spinner";
import {
    setTheme,
    setSolveType,
    setComplexity,
    setLength,
    setSpeed,
    setSetting, setTaskType
} from "../../../_actions/game/gameReduce";
import {useSnackbar} from "notistack";
import {ORDINARY} from "../../../common/taskTypes";
import {GAME, HOME} from "../../../common/links";

export default function CommonHomeworkEditorPage() {
    const {hwId} = useParams();

    const [initSetting, setInitSetting] = useState();

    const {data: setting, status, message} = useSelector(state => state.game.setting);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {enqueueSnackbar} = useSnackbar()

    useEffect(() => {
        if (!parseInt(hwId)) {
            const initStep = {
                theme: "SIMPLE_4",
                solveType: "ABACUS",
                taskType: ORDINARY,
                complexity: 1,
                speed: 1.8,
                length: 1,
                count: 10,
            }
            dispatch(setSetting(initStep))
        } else if (status === IDLE) {
            dispatch(getSettingByHWId(hwId))
        }
        if (status === SUCCESS) {
            setInitSetting(setting);
        }
    }, [status, hwId, dispatch]);
    useEffect(() => {
        if (status === FAILED) {
            enqueueSnackbar(message, {variant: "error"});
        }
    }, [message, status, enqueueSnackbar])
    useEffect(() => {
        document.title = 'КьюАй - Настройка сложности'
    }, [])

    if (status === IDLE || status === LOADING) {
        return <Spinner/>
    }

    if (status === FAILED) {
        return <Navigate to={HOME}/>
    }

    const handleChangeComplexity = (value) => {
        if (hwId) {
            if (parseInt(value) >= Math.log10(initSetting.complexity)) {
                dispatch(setComplexity(Math.pow(10, value)))
            }
        } else {
            dispatch(setComplexity(Math.pow(10, value)))
        }
    }

    const handleChangeSpeed = (value) => {
        if (hwId) {
            if (parseInt(value) <= parseInt(initSetting.speed)) {
                dispatch(setSpeed(value))
            }
        } else {
            dispatch(setSpeed(value))
        }

    }

    const handleChangeLength = (value) => {
        if (hwId) {
            if (parseInt(value) >= parseInt(initSetting.length)) {
                dispatch(setLength(value))
            }
        } else {
            dispatch(setLength(value))
        }
    }

    return (
        <Window>
            <div className="CommonHomeworkEditorPage-header">
                <div className="CommonHomeworkEditorPage-header-title">
                    Настройка сложности
                </div>
                <div className="CommonHomeworkEditorPage-header-button">
                    <CircleButton Icon={CloseIcon} onClick={() => navigate(-1)}/>
                </div>
            </div>
            <HomeworkSetting setTheme={value => dispatch(setTheme(value))}
                             theme={setting.theme}
                             disabledTheme={!!hwId}
                             setSolveType={value => dispatch(setSolveType(value))}
                             solveType={setting.solveType}
                             disabledSolveType={!!hwId}
                             setTaskType={value => dispatch(setTaskType(value))}
                             taskType={setting.taskType}
                             disabledTaskType={!!hwId}
                             setComplexity={handleChangeComplexity}
                             complexity={Math.log10(setting.complexity)}
                             setSpeed={handleChangeSpeed}
                             speed={setting.speed}
                             setLength={handleChangeLength}
                             length={setting.length}
            />
            <div className="CommonHomeworkEditorPage-bottom">
                <ButtonComponent onClick={() => navigate(GAME)}>Начать</ButtonComponent>
            </div>
        </Window>
    )
}